import React from 'react';
// $FlowFixMe: Здесь нет необходимости задавать параметры, так как мы их добавляем в провайдере
var HeaderContext = React.createContext({});
export default HeaderContext;